import { render, staticRenderFns } from "./configuration-sourcing.vue?vue&type=template&id=707b38e3&scoped=true&"
import script from "./js/configuration-sourcing.js?vue&type=script&lang=js&"
export * from "./js/configuration-sourcing.js?vue&type=script&lang=js&"
import style0 from "./configuration-sourcing.vue?vue&type=style&index=0&id=707b38e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b38e3",
  null
  
)

export default component.exports